import type {
  TicketArchiveApiData,
  TicketArchiveApiResponses,
  TicketAssignApiData,
  TicketAssignApiResponses,
  TicketCommentApiData,
  TicketCommentApiResponses,
  TicketCreateApiData,
  TicketCreateApiResponses,
  TicketDeleteApiData,
  TicketDeleteApiResponses,
  TicketEventGetApiData,
  TicketEventGetApiResponses,
  TicketEventListApiData,
  TicketEventListApiResponses,
  TicketGetApiData,
  TicketGetApiResponses,
  TicketListApiData,
  TicketListApiResponses,
  TicketPatchApiData,
  TicketPatchApiResponses,
  TicketReopenApiData,
  TicketReopenApiResponses,
  TicketResolveApiData,
  TicketResolveApiResponses,
  TicketRestoreApiData,
  TicketRestoreApiResponses,
  TicketSnoozeApiData,
  TicketSnoozeApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

// Tickets

export const getTicketUrls = {
  getPaginatedTickets: dataEndpoint<TicketListApiData, TicketListApiResponses>({
    getUrl: (queryParams) => apiUrl('tickets/', queryParams)
  }),
  getTicket: dataEndpoint<TicketGetApiData, TicketGetApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/`)
  }),
  postCreateTicket: responseEndpoint<TicketCreateApiData, TicketCreateApiResponses>({
    getUrl: () => apiUrl('tickets/'),
    getBody: (data) => data
  }),
  patchTicket: responseEndpoint<TicketPatchApiData, TicketPatchApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/`),
    getBody: ({ ticketId: _, ...body }) => body
  }),
  deleteTicket: dataEndpoint<TicketDeleteApiData, TicketDeleteApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/`)
  }),
  postTicketAssign: responseEndpoint<TicketAssignApiData, TicketAssignApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/assign/`),
    getBody: ({ ticketId: _, ...body }) => body
  }),
  postTicketSnooze: responseEndpoint<TicketSnoozeApiData, TicketSnoozeApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/snooze/`),
    getBody: ({ ticketId: _, ...body }) => body
  }),
  postTicketResolve: responseEndpoint<TicketResolveApiData, TicketResolveApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/resolve/`),
    getBody: ({ ticketId: _, ...body }) => body
  }),
  postTicketReopen: responseEndpoint<TicketReopenApiData, TicketReopenApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/reopen/`),
    getBody: ({ ticketId: _, ...body }) => body
  }),
  postTicketArchive: responseEndpoint<TicketArchiveApiData, TicketArchiveApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/archive/`),
    getBody: ({ ticketId: _, ...body }) => body
  }),
  postTicketRestore: responseEndpoint<TicketRestoreApiData, TicketRestoreApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/restore/`),
    getBody: ({ ticketId: _, ...body }) => body
  }),
  postTicketComment: responseEndpoint<TicketCommentApiData, TicketCommentApiResponses>({
    getUrl: ({ ticketId }) => apiUrl(`tickets/${ticketId}/comment/`),
    getBody: ({ ticketId: _, ...body }) => body
  }),
  getPaginatedTicketEvents: dataEndpoint<TicketEventListApiData, TicketEventListApiResponses>({
    getUrl: (queryParams) => apiUrl('ticket-events/', queryParams)
  }),
  getTicketEvent: dataEndpoint<TicketEventGetApiData, TicketEventGetApiResponses>({
    getUrl: ({ ticketEventId }) => apiUrl(`ticket-events/${ticketEventId}/`)
  })
};
